module.exports = __webpack_public_path__ + "img/2026-10-11c_1.a513f045.jpg";